<div #scrollContainer class="graph mr-1 mb-3">
 		<div class="title">
			<p class="text-left head-text">Email Settings</p>
		</div>
  <div class="filter-wrapper ml-1 mt-2">
    <form [formGroup]="emailForm">
      <div class="row">
        <!-- Contact Person Email (Required) -->
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <div class="themeinput">
            <label>Contact Person Email ID:</label>
            <input type="email" class="form-control" placeholder="" formControlName="contactPersonEmail"
              [ngClass]="{ 'is-invalid': submitted && f['contactPersonEmail'].errors }" />
            <div *ngIf="submitted && f['contactPersonEmail'].errors" class="invalid-feedback">
              <div *ngIf="f['contactPersonEmail'].errors['required']">Contact Person Email is required</div>
              <div *ngIf="f['contactPersonEmail'].errors['pattern']">Enter a valid email address</div>
            </div>
          </div>
        </div>

        <!-- CEO Email -->
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <div class="themeinput">
            <label>CEO Email ID:</label>
            <input type="email" class="form-control" placeholder="" formControlName="emailIdCeo"
              [ngClass]="{ 'is-invalid': submitted && f['emailIdCeo'].errors }" />
            <div *ngIf="submitted && f['emailIdCeo'].errors" class="invalid-feedback">
              <div *ngIf="f['emailIdCeo'].errors['required']">Contact Person Email is required</div>
              <div *ngIf="f['emailIdCeo'].errors['pattern']">Enter a valid email address</div>
            </div>
          </div>
        </div>

        <!-- Sales Email -->
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <div class="themeinput">
            <label>Sales Email ID:</label>
            <input type="email" class="form-control" placeholder="" formControlName="emailIdSales"
              [ngClass]="{ 'is-invalid': submitted && f['emailIdSales'].errors }" />
            <div *ngIf="submitted && f['emailIdSales'].errors" class="invalid-feedback">
              <div *ngIf="f['emailIdSales'].errors['required']">Contact Person Email is required</div>
              <div *ngIf="f['emailIdSales'].errors['pattern']">Enter a valid email address</div>
            </div>
          </div>
        </div>

        <!-- Non-Sales Email -->
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-4">
          <div class="themeinput">
            <label>Non-Sales Email ID:</label>
            <input type="email" class="form-control" placeholder="" formControlName="emailIdNonSales"
              [ngClass]="{ 'is-invalid': submitted && f['emailIdNonSales'].errors }" />
            <div *ngIf="submitted && f['emailIdNonSales'].errors" class="invalid-feedback">
              <div *ngIf="f['emailIdNonSales'].errors['pattern']">Enter a valid email address</div>
            </div>
          </div>
        </div>

        <!-- Service Email -->
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-4">
          <div class="themeinput">
            <label>Service Email ID:</label>
            <input type="email" class="form-control" placeholder="" formControlName="emailIdService"
              [ngClass]="{ 'is-invalid': submitted && f['emailIdService'].errors }" />
            <div *ngIf="submitted && f['emailIdService'].errors" class="invalid-feedback">
              <div *ngIf="f['emailIdService'].errors['pattern']">Enter a valid email address</div>
            </div>
          </div>
        </div>

        <!-- Spares Email -->
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-4">
          <div class="themeinput">
            <label>Spares Email ID:</label>
            <input type="email" class="form-control" placeholder="" formControlName="emailIdSpares"
              [ngClass]="{ 'is-invalid': submitted && f['emailIdSpares'].errors }" />
            <div *ngIf="submitted && f['emailIdSpares'].errors" class="invalid-feedback">
              <div *ngIf="f['emailIdSpares'].errors['pattern']">Enter a valid email address</div>
            </div>
          </div>
        </div>

        <!-- Alternate Email -->
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-4">
          <div class="themeinput">
            <label>Alternate Email ID:</label>
            <input type="email" class="form-control" placeholder="" formControlName="alternateEmailId"
              [ngClass]="{ 'is-invalid': submitted && f['alternateEmailId'].errors }" />
            <div *ngIf="submitted && f['alternateEmailId'].errors" class="invalid-feedback">
              <div *ngIf="f['alternateEmailId'].errors['pattern']">Enter a valid email address</div>
            </div>
          </div>
        </div>

        <!-- Non-Sales Insurance Email -->
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-4">
          <div class="themeinput">
            <label>Non-Sales Insurance Email ID:</label>
            <input type="email" class="form-control" placeholder="" formControlName="non_sales_insurance_email"
              [ngClass]="{ 'is-invalid': submitted && f['non_sales_insurance_email'].errors }" />
            <div *ngIf="submitted && f['non_sales_insurance_email'].errors" class="invalid-feedback">
              <div *ngIf="f['non_sales_insurance_email'].errors['pattern']">Enter a valid email address</div>
            </div>
          </div>
        </div>

        <!-- Non-Sales Finance Email -->
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-4">
          <div class="themeinput">
            <label>Non-Sales Finance Email ID:</label>
            <input type="email" class="form-control" placeholder="" formControlName="non_sales_finance_email"
              [ngClass]="{ 'is-invalid': submitted && f['non_sales_finance_email'].errors }" />
            <div *ngIf="submitted && f['non_sales_finance_email'].errors" class="invalid-feedback">
              <div *ngIf="f['non_sales_finance_email'].errors['pattern']">Enter a valid email address</div>
            </div>
          </div>
        </div>

        <!-- Non-Sales Best Value Email -->
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-4">
          <div class="themeinput">
            <label>Non-Sales Best Value Email ID:</label>
            <input type="email" class="form-control" placeholder="" formControlName="non_sales_bestvalue_email"
              [ngClass]="{ 'is-invalid': submitted && f['non_sales_bestvalue_email'].errors }" />
            <div *ngIf="submitted && f['non_sales_bestvalue_email'].errors" class="invalid-feedback">
              <div *ngIf="f['non_sales_bestvalue_email'].errors['pattern']">Enter a valid email address</div>
            </div>
          </div>
        </div>

        <!-- Non-Sales Accessories Email -->
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-4">
          <div class="themeinput">
            <label>Non-Sales Accessories Email ID:</label>
            <input type="email" class="form-control" placeholder="" formControlName="non_sales_accessories_email"
              [ngClass]="{ 'is-invalid': submitted && f['non_sales_accessories_email'].errors }" />
            <div *ngIf="submitted && f['non_sales_accessories_email'].errors" class="invalid-feedback">
              <div *ngIf="f['non_sales_accessories_email'].errors['pattern']">Enter a valid email address</div>
            </div>
          </div>
        </div>

        <!-- Non-Sales Service Info Email -->
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-4">
          <div class="themeinput">
            <label>Non-Sales Service Info Email ID:</label>
            <input type="email" class="form-control" placeholder="" formControlName="non_sales_service_info_email"
              [ngClass]="{ 'is-invalid': submitted && f['non_sales_service_info_email'].errors }" />
            <div *ngIf="submitted && f['non_sales_service_info_email'].errors" class="invalid-feedback">
              <div *ngIf="f['non_sales_service_info_email'].errors['pattern']">Enter a valid email address</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-4">
          <div class="themeinput">
            <label>P & S Email ID:</label>
            <input type="email" class="form-control" placeholder="" formControlName="p_s_email"
              [ngClass]="{ 'is-invalid': submitted && f['p_s_email'].errors }" />
            <div *ngIf="submitted && f['p_s_email'].errors" class="invalid-feedback">
              <div *ngIf="f['p_s_email'].errors['pattern']">Enter a valid email address</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-lg-12 mt-3">
          <div class="text-right-right">
            <!-- <button style="width: 180px;" class="btn back-btn mr-3" mat-raised-button (click)="back()"><span
              class="mr-2"><img style="transform: rotate(270deg);" src="/assets/images/up-arrow.png"
                alt=""></span>Back</button> -->
            <button style="width: 180px;" class="btn blue-btn" mat-raised-button (click)="updateEmailDetails()">Submit</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>